
import React from "react";
import { Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface UserActionsProps {
  onEdit: () => void;
  onDelete: () => void;
}

export const UserActions: React.FC<UserActionsProps> = ({ onEdit, onDelete }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white p-4 border-t border-gray-200">
      <div className="flex justify-between gap-4">
        <Button 
          type="button" 
          className="flex-1 bg-[#BD1E28] hover:bg-[#A01822] text-white"
          onClick={onEdit}
        >
          <Pencil className="w-4 h-4 mr-2" />
          Modifier
        </Button>
        <Button 
          type="button"
          variant="outline" 
          className="flex-1"
          onClick={onDelete}
        >
          <Trash2 className="w-4 h-4 mr-2" />
          Supprimer
        </Button>
      </div>
    </div>
  );
};
